import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';

export function onNoticeBoardResponse(response) {
  return {
    type: types.NOTICEBOARD_RESPONSE,
    response
  };
}
export function onNoticeBoardDetailResponse(response) {
  return {
    type: types.NOTICEBOARD_DETAIL_RESPONSE,
    response
  };
}

export const noticeBoardList = async (params, dispatch) => {
  const jwtToken = params;
  const body = {};
  const url = 'api/student/noticeboard';

  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      dispatch(onNoticeBoardResponse(data));
    });
};

export const noticeBoardDetail = async (params, uniqueCode, dispatch) => {
  const jwtToken = params;
  const UniqueCode = uniqueCode;
  const body = {
    UniqueCode: UniqueCode
  };
  const url = 'api/student/noticeboard';

  return await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      dispatch(onNoticeBoardDetailResponse(data));
      return data;
    });
};
